import { setSelectedAccountSummary } from "../../../shared/lib/auth/accountContext";
import {
  buildAccountInfo,
  buildAccountShellSummary,
  resolveAccountLogo,
} from "./accountFormatters";

export function buildAccountStoreState(profile, accountId = "") {
  return {
    accountId: accountId || profile?.account_id || profile?.id || "",
    error: "",
    info: buildAccountInfo(profile),
    logoError: "",
    logoLoading: false,
    logoUrl: resolveAccountLogo(profile),
    loaded: true,
    loading: false,
    planName: profile?.plan_name || "",
    profile,
  };
}

export function buildAccountUserState(user, profile, shellSummary) {
  const profilePermissions = profile?.permissions && typeof profile.permissions === "object"
    ? profile.permissions
    : null;
  const permissionsLoaded = Boolean(
    shellSummary?.permissionsLoaded ||
    Object.prototype.hasOwnProperty.call(profile || {}, "permissions") ||
    Object.prototype.hasOwnProperty.call(profile || {}, "permission_levels") ||
    Object.prototype.hasOwnProperty.call(profile || {}, "permission_slugs") ||
    Object.prototype.hasOwnProperty.call(profile || {}, "capabilities")
  );
  const isAccountOwner = Boolean(
    profile?.is_account_owner ||
    profile?.isAccountOwner ||
    shellSummary?.isAccountOwner ||
    user?.is_account_owner ||
    user?.isAccountOwner
  );

  return {
    ...user,
    accountLogoUrl: shellSummary.logoUrl,
    accountName: shellSummary.name,
    accountStatus:
      profile?.account_status ||
      profile?.accountStatus ||
      shellSummary.status ||
      user?.accountStatus ||
      user?.account_status ||
      null,
    account_status:
      profile?.account_status ||
      profile?.accountStatus ||
      shellSummary.status ||
      user?.account_status ||
      user?.accountStatus ||
      null,
    avatar_config: profile?.avatar_config || user?.avatar_config,
    avatar_url:
      profile?.avatar_url ||
      profile?.user_avatar_url ||
      profile?.picture_url ||
      user?.avatar_url,
    name: profile?.display_name || profile?.name || user?.name,
    nickname: profile?.nickname ?? user?.nickname,
    is_account_owner: isAccountOwner,
    isAccountOwner,
    picture:
      profile?.picture_url ||
      profile?.avatar_url ||
      profile?.user_avatar_url ||
      user?.picture,
    picture_url:
      profile?.picture_url ||
      profile?.avatar_url ||
      profile?.user_avatar_url ||
      user?.picture_url,
    permissions: profilePermissions || user?.permissions || null,
    permissionsLoaded,
    permission_levels:
      profilePermissions?.permission_levels ??
      profile?.permission_levels ??
      user?.permission_levels ??
      null,
    permission_slugs:
      profilePermissions?.permission_slugs ??
      profile?.permission_slugs ??
      user?.permission_slugs ??
      null,
    user_avatar_url:
      profile?.user_avatar_url ||
      profile?.avatar_url ||
      profile?.picture_url ||
      user?.user_avatar_url,
  };
}

export function syncAccountProfileToShell({
  profile,
  setAccountState,
  updateAuthenticatedUser,
  user,
}) {
  const shellSummary = buildAccountShellSummary(profile, user?.accountId);

  if (user?.email) {
    setSelectedAccountSummary(user.email, shellSummary);
  }

  if (user && updateAuthenticatedUser) {
    updateAuthenticatedUser(buildAccountUserState(user, profile, shellSummary));
  }

  if (setAccountState) {
    setAccountState(buildAccountStoreState(profile, user?.accountId));
  }

  return shellSummary;
}
